import React, { useState } from 'react'
import { Route } from 'react-router'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { StyledColItem } from 'components/SectionHandler'
import config from './config'
import SectionHandler from 'components/SectionHandler'

const SectionContainer = styled.div`
	margin-top: 10px;
	div${StyledColItem} {
		max-width: none;
	}
`

const OrdersHandler = (props) => {
	const [t] = useTranslation()
	const [openModal, setOpenModal] = useState(false)
	const sections = config(t, openModal, setOpenModal)
	return(
		<SectionContainer>
			<Route path={`/:mainSection/kasse-global/:section/:id?`} render={routerProps => (
				<SectionHandler
					{...routerProps}
					sections={sections}
					sectionPathRedirect={false}
					replaceOnlyIdOnRoute={true}
					navBarProps={{ withoutTopMenu: true, hideLabel: true }}
					listFetchPolicy='cache-and-network'
				/>
			)}/>
		</SectionContainer>
	)
}

export default OrdersHandler
